import Label from 'Components/Label';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setExpedienteId, setId } from '../../../../redux/slices';
import CreditoService from 'Services/Http/Credito.service';
import SearchBar from 'Components/SearchBar';
import ProgressBar from 'Components/ProgressBar';
import { formatCurrency } from 'Utils/Functions';
import CardStadistics from 'Components/CardStadistics';
import Button from 'Components/Button';
import ModalComponent from 'Components/Modal';
import PagosService from 'Services/Http/Pagos.service';
import SelectUsers from 'Components/SelectUsers';
import EstadisticasService from 'Services/Http/Estadisticas.service';

const ListarMoraComponente = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [clientes, setClientes] = useState([]);
  const [loader, setLoader] = useState(false);
  const [creditos, setCreditos] = useState(0);
  const [totalClientes, setTotalClientes] = useState(0);
  const [mora, setMora] = useState(0);
  const [pagado, setPagado] = useState(0);
  const [idUser, setIdUser] = useState(null);
  const { pagos } = useSelector((state) => state.session.session);
  const [item, setItem] = useState({});
  const [modalState, setModalstate] = useState(false);
  const [urlReport, setUrlReport] = useState('');

  useEffect(() => {
    getAllClientes();
  }, []);

  const getAllClientes = async (text) => {
    setLoader(true);
    try {
      setClientes([]);
      const urlResponse = await EstadisticasService.downloadMora({ idUser });
      setUrlReport(urlResponse.data);
      const response = await CreditoService.getMora({ idUser, ...text });
      setDataCards(response.data);
      createRows(response.data.records);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  const openFile = () => {
    let w = window.open(urlReport, '_blank');
    w.opener = null;
  };

  const activeExpedient = (uuid, id, idExpediente) => {
    if (pagos) {
      const url = '/main/validacion/' + uuid + '/autorizado';
      const dataId = [];
      dataId[uuid] = id;
      dispatch(setId(dataId));
      dispatch(setExpedienteId(idExpediente));
      goTo(url);
    }
  };

  const setDataCards = (data) => {
    setCreditos(data.creditos);
    setTotalClientes(data.clientes);
    setMora(formatCurrency(data.mora));
    setPagado(formatCurrency(data.pagado));
  };

  const goTo = (url) => {
    navigate(url);
  };
  const createRows = (rows) => {
    let data = rows.map((item, index) => (
      <tr
        key={'clientes-row-' + index}
        className="odd:bg-white even:bg-blue-100 border-b hover:bg-blue-300 hover:cursor-pointer">
        <td
          className="px-3 py-2"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.id}
        </td>
        <td
          className="px-3 py-2"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.nombreCompleto}
        </td>
        <td
          className="px-3 py-2"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.etiquetaCredito}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.fechaProximoPago}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {formatCurrency(item.pago)}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.atraso}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {formatCurrency(item.totalPagos)}
        </td>
        <td
          className="px-6 py-4 text-red-600 font-bold"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {formatCurrency(item.adeudoVencido)}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {formatCurrency(item.faltante)}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {formatCurrency(item.montoTotal)}
        </td>
        <td
          className="px-6 py-4"
          onClick={() => activeExpedient(item.uuid, item.id, item.idExpediente)}>
          {item.asignado}
        </td>
        <td className="px-6 py-4">
          {item.fechaCompromiso ? (
            <div>
              <div>{item.nameDayWeek}</div>
              <div>{item.fechaCompromiso}</div>
              <div>{formatCurrency(item.montoCompromiso)}</div>
              <div>{item.obsCompromiso}</div>
            </div>
          ) : (
            <Button label="Compromiso" onClick={() => openModalCompromiso(item)} />
          )}
        </td>
      </tr>
    ));
    setClientes(data);
    setLoader(false);
  };
  const find = async (text) => {
    setClientes([]);
    getAllClientes(text);
  };

  useEffect(() => {
    getAllClientes();
  }, [idUser]);

  const saveData = async (data, loader) => {
    loader(true);
    try {
      await PagosService.saveCompromiso(data);
      getAllClientes();
      setModalstate(false);
      loader(false);
    } catch (e) {
      console.log(e);
      setModalstate(false);
      loader(false);
    }
  };

  const openModalCompromiso = (item) => {
    console.log(item);
    setItem(item);
    setModalstate(true);
  };

  return (
    <>
      <Label text={'Creditos en mora'} />
      <div className="flex flex-col grid grid-cols-1 md:grid md:grid-flow-col md:grid-cols-2 md:flex-row gap-3 my-3 justify-stretch">
        <div className="flex order-2 md:order-1">
          <SearchBar find={find} reload={getAllClientes} />
        </div>
      </div>
      {pagos ? (
        <div className="flex flex-row my-5 lg:w-2/5 md:w-100 justify-stretch">
          <SelectUsers onChange={setIdUser} />
          <Button iconprefix={['fa', 'download']} onClick={() => openFile()} />
        </div>
      ) : (
        ''
      )}
      <div className="flex flex-col grid lg:grid-cols-4 md:grid-cols-2 gap-3 my-3 justify-stretch">
        <CardStadistics title={'Creditos'} texto={creditos} />
        <CardStadistics title={'Clientes'} texto={totalClientes} />
        <CardStadistics title={'Mora'} texto={mora} />
        <CardStadistics title={'Pagado'} texto={pagado} />
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left rtl:text-right text-black">
          <thead className="text-xs text-white uppercase bg-blue-500">
            <tr>
              <th scope="col" className="px-6 py-3">
                #
              </th>
              <th scope="col" className="px-6 py-3">
                Nombre completo
              </th>
              <th scope="col" className="px-6 py-3">
                Credito
              </th>
              <th scope="col" className="px-6 py-3">
                Fecha de pago
              </th>
              <th scope="col" className="px-6 py-3">
                Pago
              </th>
              <th scope="col" className="px-6 py-3">
                Dias de atraso
              </th>
              <th scope="col" className="px-6 py-3">
                Pagado
              </th>
              <th scope="col" className="px-6 py-3">
                Adeudo Vencido
              </th>
              <th scope="col" className="px-6 py-3">
                Adeudo Total
              </th>
              <th scope="col" className="px-6 py-3">
                Total de Credito
              </th>
              <th scope="col" className="px-6 py-3">
                Asignado
              </th>
              <th scope="col" className="px-6 py-3"></th>
            </tr>
          </thead>
          <tbody>{clientes}</tbody>
        </table>
        {loader ? <ProgressBar /> : ''}
      </div>
      <ModalComponent
        show={modalState}
        changeState={setModalstate}
        typeModal="compromiso"
        actionOK={saveData}
        title={'Cual es la fecha de compromiso'}
        params={item}
      />
    </>
  );
};

export default ListarMoraComponente;
